<template>
  <div v-if="showBar">
    <div class="h-24 bg-beige fixed bottom-0 left-0 w-full z-50 p-4 flex items-center shadow">
        <div class="container flex justify-between items-center">
            <h4 class="lg:block hidden text-black">{{ item.name[trans.locale] }}</h4>
            <slot></slot>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  data() {
    return {
     showBar: false
    }
  },
  methods: {
    dynamicHeight() {
      const headerHeight = 60;
      const detailContainer = 380;
      const mobileThreshold = 800;
      const desktopThreshold = 350;

      window.addEventListener('scroll', () => {
        const scrollThreshold = window.innerWidth <= 1024 ? mobileThreshold : desktopThreshold;
        this.showBar = window.scrollY > headerHeight + detailContainer + scrollThreshold
      });
    },
  },
  mounted() {
    this.dynamicHeight();
  },
}
</script>
